import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import types from '../../common/model-api/types';
import Editor from '../fw/Editor.react';

import {Link} from 'react-router';
import {ButtonGroup} from 'react-bootstrap';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AddButton from '../fw/AddButton.react';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import DeleteButton from '../fw/DeleteButton.react';
import * as BrowserPermission from "../BrowserPermission";
import {getProfile} from '../app/auth.js';
import {ASCENDING} from '../fw/Grid.react';
import {NOTIFY_FREQ_O2U, OrganisationRole, ROLE_OWNER, ROLE_USER} from '../../common/model-api/Organisation2UserType';
import SaveRoleMutation from './SaveRoleMutation.react';
import LoadingButtonNew from '../fw/LoadingButtonNew.react';
import EventTracker from '../app/EventTracker';
import ResendInvitationMutation from '../invitations/ResendInvitationMutation';
import mutationError from '../channel-defs/mutationError';
import {ErrorModal} from '../app/errorDisplayer';
import * as Permission from '../../common/util/Permission';

import '../users/User.scss';
import { NOTIFY_FREQ } from '../../common/model-api/UserType';
import UpdateErrorsMutation from './UpdateErrorsMutation.react';
import { key } from 'react-router-breadcrumbs';
import Select from 'react-select';
import UpdateErrorsUserMutation from '../admin/UpdateErrorsUserMutation.react';

const messages = defineMessages({
    title: {id: 'userList.title', 'defaultMessage': 'Users'},
	invitation: {id: 'userList.inviteUser', defaultMessage: 'Inviate user'},
	cancel: {id: 'common.cancel', defaultMessage: 'Cancel'},
	save: {id: 'common.save', defaultMessage: 'Save'},
    notifyErrors: {id: 'adminUserEdit.notifyErrors', 'defaultMessage': 'Notify errors'},
    notifyErrorsFreq: {id: 'adminUserEdit.notifyErrorsFreq', 'defaultMessage': 'Notify errors frequency'},
});

class Organisation2UserNotificationsList extends React.Component {

    typeName = 'organisation2user';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

	constructor(props) {
		super(props);

		this.state = {
			loggerUserEmail: null,
			notifyErrorsObject: this.getNotifyErrorsObject(props),
            notifyErrors: props.user.notifyErrors,
            freq: props.user.notifyErrorsFreq,
		};
	}

    getNotifyErrorsObject(props) {
        let notifyErrorsObject = {};
        let isGlobalOff = false;

        if (!props.user.notifyErrors) {
            isGlobalOff = true;
        }

        props.user.organisations2user.edges.forEach(({node}) => {
            notifyErrorsObject[node.organisation.realId] = {
                notifyErrors: isGlobalOff ? false : node.notifyErrors,
                notifyErrorsFreq: node.notifyErrorsFreq,
                org2UserId: node.realId,
            };
        });

        // Sort the organisations2user by organisation name
        props.user.organisations2user.edges.sort((a, b) => {
            let aName = a.node.organisation.name.toLowerCase();
            let bName = b.node.organisation.name.toLowerCase();
            if (aName < bName) {
                return -1;
            } else if (aName > bName) {
                return 1;
            } else {
                return 0;
            }
        });

        return notifyErrorsObject;
    }

    componentWillMount() {
        getProfile().then((profile) => {
            this.setState({'loggerUserEmail': profile.email});
        }).catch(() => {});
    }

	updateOrg2User() {
        return new Promise((resolve, reject) => {
            try {
                let notifyErrors = this.state.notifyErrors;
                let notifyErrorsFreq = this.state.freq;

                this.props.relay.commitUpdate(
                    new UpdateErrorsUserMutation({
                        user_id: this.props.user.realId,
                        notifyErrors: notifyErrors,
                        notifyErrorsFreq: notifyErrorsFreq,
                    }), {onSuccess: () => {}, onFailure: () => {}}
                );

                for (let [key, value] of Object.entries(this.state.notifyErrorsObject)) {
                    // let state = this.state.notifyErrorsObject[row.organisation.realId];
                    this.props.relay.commitUpdate(
                        new UpdateErrorsMutation({
                            notifyErrorsFreq: value['notifyErrorsFreq'],
                            id: value['org2UserId'],
                            notifyErrors: value['notifyErrors'],
                        }), {onSuccess: () => {}, onFailure: () => {}}
                    );
                }
                this.setState({"isSaveSuccess": true});
                resolve();
            } catch (e) {
                this.setState({"isSaveError": true});
                reject(e);
            }
        });
	}

    changeItem(row, newValue, key) {
		let notifyErrorsObject = this.state.notifyErrorsObject;
        let oldValue = notifyErrorsObject[row.organisation.realId][key];

        // if (newValue === "on") {
        //     newValue = true;
        // } else {
        //     newValue = false;
        // }

        console.log("CHANGING", oldValue, newValue);

        notifyErrorsObject[row.organisation.realId][key] = newValue;

		this.setState({
			notifyErrorsObject: notifyErrorsObject
		});
	}

    render() {
        let type = types[this.typeName];
        let userType = types['users'];

        let freqs = [];
        freqs.push({value: '', label: '-'});

        for (let [k, v] of Object.entries(NOTIFY_FREQ_O2U)) {
            freqs.push({value: k, label: this.props.intl.formatMessage({defaultMessage: v.name, id: "metadata.organisation2user.notifyErrorsFreq.values." + k + ".name"})});

        }

        return (
            <AppPanel breadcrumbParams={[
				{type: type, text: this.props.intl.formatMessage(messages.title)},
                {type: types['organisations'], data: this.props.user.organisation}
			]}
			className="Organisation2Users"
			title={this.props.intl.formatMessage(messages.title)}>
            <div>
                <h3>{<FormattedMessage defaultMessage="Global notification settings" id="organisation2user.globalNotificationSettings" />}</h3>
                <div className='col-md-3'>{<FormattedMessage defaultMessage="Notify errors" id="adminUserEdit.notifyErrors" />}</div>
                <div className='col-md-9' style={{marginBottom: '2rem'}}>
                    <input
                        checked = {this.state.notifyErrors}
                        label={this.props.intl.formatMessage(messages.notifyErrors)}
                        name={"notifyErrors"}
                        onClick={(value) => {
                            this.setState({notifyErrors: !this.state.notifyErrors});
                        }}
                        type = "checkbox"
                    />
                </div>

                {this.state.notifyErrors ? <div>
                <div className='col-md-3'>{<FormattedMessage defaultMessage="Notify errors frequency" id="adminUserEdit.notifyErrorsFreq" />}</div>
                <div className='col-md-9' style={{marginBottom: '2rem'}}>
                    <Select
                        label={this.props.intl.formatMessage(messages.notifyErrorsFreq)}
                        name={"notifyErrorsFreq"}
                        onChange={(value) => {
                            this.setState({freq: value.value});
                        }}
                        options={freqs.filter((a) => a.value !== 'global')}
                        value={freqs.find((a) => a.value === this.state.freq)}
                    />
                </div>

                </div> : null}
            </div>


                {this.state.notifyErrors ? <div>
                <h3>{<FormattedMessage defaultMessage="Notification settings for individual organizations" id="organisation2user.individualOrganisationSettings" />}</h3>
                    {this.state.notifyErrors && <div style={{position: 'relative'}}>
						<PagingGrid
							columns={{
								'organisation.name': {
									width: 25,
									withoutMapping: true,
									header: (<FormattedMessage defaultMessage="Organisation" id="org2user.organisation" />),
									link: false,
									showAlways: true,
									className: (item) => {
										return item.organisation === true ? 'organisation' : null;
									},
									render: (column, item) => {
										let {organisation} = item;
										let name = (organisation.name).trim();

										if (!name) {
											name = '-';
										}

										return (
											<div>
												<span className="name">{name}</span>
											</div>
										);
									}
								},
                                'notifyErrors': {
									width: 25,
									link: false,
									showAlways: true,
									className: (item) => {
										return item.organisation === true ? 'organisation' : null;
									},
									// eslint-disable-next-line max-params
									render: (column, item, url, columnMapping) => {
                                        let key = "notifyErrors";
                                        let state = this.state.notifyErrorsObject[item.organisation.realId];
										return (
                                            <input checked={state?.[key]} onClick={(event) => { this.changeItem(item, !state?.[key], key); }} type="checkbox">
                                                </input>
                                        );
									}
								},
								'notifyErrorsFreq': {
									width: 25,
									link: false,
									showAlways: true,
									className: (item) => {
										return item.organisation === true ? 'organisation' : null;
									},
                                    visible: (item) => {
                                        return this.state.notifyErrorsObject[item.organisation.realId]?.notifyErrors;
                                    },
									// eslint-disable-next-line max-params
									render: (column, item, url, columnMapping) => {
                                        let key = "notifyErrorsFreq";
                                        let state = this.state.notifyErrorsObject[item.organisation.realId];
										return (
                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: "space-between"}}>
                                                <select  className="textValue form-control" onChange={(event) => { this.changeItem(item, event.target.value, key); }} style={{maxWidth: "200px"}} value={state?.[key]}>
                                                    {Object.keys(NOTIFY_FREQ_O2U).map(value => {
                                                        return (<option key={value} value={value}>
                                                            {this.props.intl.formatMessage({defaultMessage: NOTIFY_FREQ_O2U[value].name, id: "metadata.organisation2user.notifyErrorsFreq.values." + value + ".name"})}</option>);
                                                    })}
                                                </select>
                                            </div>
                                        );
									}
								},
							}}
							edges={this.props.user.organisations2user}
							filterUndefinedColumns={false}
							firstLevelTypes
							metadata={type}
							pageInfo={this.props.user.organisations2user.pageInfo}
							parent={this.props.user}
							relay={this.props.relay}
							urlMapping={urlMapping} />

                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'start'}}>
                            <LoadingButtonNew className="btn btn-primary" doneText={<FormattedMessage defaultMessage="Saved" id="common.saved" />} onClick={() => { this.updateOrg2User(); }} progressText={(<FormattedMessage defaultMessage="Saving…" id="common.saving" />)} text={<FormattedMessage defaultMessage="Save" id="common.save" />}title={this.props.intl.formatMessage(messages.save)}></LoadingButtonNew>
                            {this.state.isSaveError && <div><span className="text-danger"><FormattedMessage defaultMessage="An error occurred" id="common.error" /></span></div>}
                            {this.state.isSaveSuccess && <div><span className="text-success"><FormattedMessage defaultMessage="Successfully saved!" id="common.success" /></span></div>}
                            </div>
					</div>}
                </div> : null}
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(Organisation2UserNotificationsList), (props) => {
    return true;
}), {
    initialVariables: {
        userId: null,
        first: defaultPageSize,
        after: null,
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                instance_id,
                firstname,
                notifyErrors,
                notifyEmail,
                notifyErrorsFreq,
                globalPermissions,
                surname,
                company,
                email,
                organisations2user(first: $first, after: $after) {
                    edges {
                        node {
                            id,
                            realId,
                            organisation_id,
                            organisation {
                                id,
                                realId,
                                name,
                                billedBy {
                                    id,
                                    realId,
                                    name,
                                },
                            },
                            role,
                            createdAt,
                            notifyErrorsFreq,
                            notifyErrors
                        }
                    },
                    pageInfo {
						hasNextPage,
						hasPreviousPage,
						startCursor,
						endCursor
					}
                },
            }
        `,
    },
});
